import {axiosCustom} from "@/plugins/axios";

export class Group {
  getUserGroupsInSystem() {
    return axiosCustom
      .get('/api/group')
      .then((response) => response.data);
  }
}
